import React from 'react';
import style from './newFlightRequestButton.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { newFlightRequest } from '../routeHelper';

interface NewFlightRequestButtonProps {
    centreAlign: boolean;
}

const NewFlightRequestButton: React.SFC<NewFlightRequestButtonProps> = ({centreAlign}) => (
    <Link to={newFlightRequest()}>
        <span className={classNames(style.NewEnquiry, centreAlign ? style.CentreAlign : style.LeftAlign)}>
            <FormattedMessage
                id={'components.flightRequest.newFlightRequestButton.newEnquiry'}
                defaultMessage={'NEW ENQUIRY'}
            />
        </span>
    </Link>
);

export { NewFlightRequestButton };
